import Account from "pages/Account/Account";
import AppsPage from "pages/Apps";
import BlockchainPage from "pages/BlockchainPage";
import Devices from "pages/Devices";
import ForgotPassword from "pages/ForgotPassword";
import IPTablePage from "pages/IPTablePage";
import Login from "pages/Login";
import AccessManagement from "pages/Management/AccessManagement";
import OrganizationManagement from "pages/Management/OrganizationManagement";
import ManagePlansPage from "pages/ManagePlans";
import MultiDashboardPage from "pages/MultiDashboard";
import Networks from "pages/Networks";
import PricingPlansPage from "pages/PricingPlansPage";
import RemoteConsolePage from "pages/RemoteConsole";
import ResetPassword from "pages/ResetPassword";
import SignUp from "pages/Signup";
import SingleDashboardPage from "pages/SingleDashboard";
import SingleNetworkPage from "pages/SingleNetworkPage";
import TwoFactorSetupPage from "pages/TwoFactorSetup";
import SecurebootActivityPage from "pages/SecurebootActivity";
import SecureBootPage from "pages/SecureBoot";
import SecureBootDeviceUsersPage from "pages/SecureBootDeviceUsers";
import BugReport from "pages/BugReport";
import ThreatsIncidentsPage from "pages/ThreatsIncidents";
import ThreatIncidentDetailPage from "pages/ThreatIncidentDetail";
import ZeroTrustPoliciesPage from "pages/ZeroTrustPolicies";
import ZeroTrustPolicyDetailPage from "pages/ZeroTrustPolicyDetail";
import ComplianceReportsPage from "pages/ComplianceReports";
import ComplianceReportDetailPage from "pages/ComplianceReportDetail";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import SubscriptionPage from "../../pages/Subscription";
import PrivateLayoutRoutes from "./PrivateLayoutRoutes";
import PrivateNoLayoutRoutes from "./PrivateNoLayoutRoutes";
import PrivateSubscriptionRoutes from "./PrivateSubscriptionRoutes";
import CDashboard from "pages/CDashboard";
import SocDashboardPage from "pages/SocDashboard";
import HipaaDetail from "components/newDesign/hipaa/HipaaDetail";
import BlockChain from "components/newDesign/blockChain/BlockChain";
import PhishingDetail from "components/newDesign/phishing/PhishingDetail";
import RiskScoreDetail from "components/newDesign/riskScore/RiskScoreDetail";
import CriticalOtDetail from "components/newDesign/criticalOt/CriticalOtDetail";
import ZeroTrustHealth from "components/newDesign/zeroTrustHealth/ZeroTrustHealthDetail";
import AIContextualizationReport from "components/newDesign/aiContextualization/AIContextualizationReport";

const MyRouter = () => {
  return (
    <Router>
      <Routes>
        <Route element={<PrivateLayoutRoutes />}>
          <Route path="/single-dashboard" element={<Devices />} />
          <Route path="/apps" element={<AppsPage />} />
          <Route
            path="/single-dashboard/:id"
            element={<SingleDashboardPage />}
          />
          <Route path="/ip-table/:id" element={<IPTablePage />} />
          {/* <Route path="/" element={<MultiDashboardPage />} /> */}
          <Route path="/" element={<CDashboard />} />
          <Route path="/cDashboard/risk-score" element={<RiskScoreDetail />} />
          <Route path="/cDashboard/zero-trust" element={<ZeroTrustHealth />} />
          <Route
            path="/cDashboard/ai-contextualization-report"
            element={<AIContextualizationReport />}
          />
          <Route path="/cDashboard/block-chain" element={<BlockChain />} />
          <Route
            path="/cDashboard/phishing-events"
            element={<PhishingDetail />}
          />
          <Route
            path="/cDashboard/hipaa-compliance"
            element={<HipaaDetail />}
          />
          <Route
            path="/cDashboard/critical-ot-assets"
            element={<CriticalOtDetail />}
          />
          <Route path="/soc-dashboard" element={<SocDashboardPage />} />
          <Route path="/threats-incidents" element={<ThreatsIncidentsPage />} />
          <Route
            path="/threats-incidents/:id"
            element={<ThreatIncidentDetailPage />}
          />
          <Route
            path="/zero-trust-policies"
            element={<ZeroTrustPoliciesPage />}
          />
          <Route
            path="/zero-trust-policies/:id"
            element={<ZeroTrustPolicyDetailPage />}
          />
          <Route
            path="/compliance-reports"
            element={<ComplianceReportsPage />}
          />
          <Route
            path="/compliance-reports/:id"
            element={<ComplianceReportDetailPage />}
          />

          <Route path="/account" element={<Account />} />
          <Route
            path="/portal-access-management"
            element={<AccessManagement />}
          />
          <Route
            path="/organization-access-management"
            element={<OrganizationManagement />}
          />
          <Route path="/networks" element={<Networks />} />
          <Route path="/single-network/:id" element={<SingleNetworkPage />} />
          <Route path="/blockchain/tx/:txnId" element={<BlockchainPage />} />
          <Route path="/manage-plans" element={<ManagePlansPage />} />
          <Route path="/secureboot" element={<SecureBootPage />} />
          <Route
            path="/secureboot/:id/users"
            element={<SecureBootDeviceUsersPage />}
          />
          <Route path="/bug-report" element={<BugReport />} />
        </Route>

        <Route element={<PrivateNoLayoutRoutes />}>
          <Route path="/console" element={<RemoteConsolePage />} />
        </Route>

        <Route element={<PrivateSubscriptionRoutes />}>
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/pricing" element={<PricingPlansPage />} />
        </Route>

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route
          path="/sign-up-two-factor/:uuid"
          element={<TwoFactorSetupPage />}
        />
        <Route
          path="/secureboot-user-activity/:userId"
          element={<SecurebootActivityPage />}
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </Router>
  );
};

export default MyRouter;
